import StatementPage from "components/pages/StatementPage";

export default function CaptureEStatementsStatement(props) {
    return <StatementPage />
}